// import React from "react";
// import {
//   TextField,
//   Box,
//   Typography,
//   Tooltip,
// } from "@mui/material";
// // import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import InfoIcon from "@mui/icons-material/Info";
// import { useTheme } from "@mui/material/styles";

// const CustomInput = ({
//   label,
//   tooltip,
//   type = "text",
//   value,
//   onChange,
//   required = false,
//   InputProps = {},
//   placeholder,
//   children,
//   ...props
// }) => {
//   const theme = useTheme();

//   return (
//     <Box>
//       {label && (
//         <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
//           <Typography
//             variant="body2"
//             sx={{
//               fontWeight: 600,
//               color: theme.palette.text.primary,
//             }}
//           >
//             {label}
//             {required && (
//               <Box
//                 component="span"
//                 sx={{
//                   color: theme.palette.error.main,
//                   ml: 0.25,
//                 }}
//               >
//                 *
//               </Box>
//             )}
//           </Typography>

//           {tooltip && (
//             <Tooltip title={tooltip} placement="top">
//               <InfoIcon
//                 sx={{
//                   ml: 0.5,
//                   fontSize: 16,
//                   color: "text.secondary",
//                   cursor: "pointer",
//                 }}
//               />
//             </Tooltip>
//           )}
//         </Box>
//       )}

//       <TextField
//         required={required}
//         type={type}
//         value={value}
//         onChange={onChange}
//         fullWidth
//         variant="outlined"
//         sx={{
//           mb: 1.5,
//           position: "relative",
//           "& .MuiFormLabel-asterisk": {
//             color: theme.palette.error.main,
//             fontWeight: 600,
//           },
//           "& .MuiFormHelperText-root": {
//             position: "absolute",
//             bottom: "-18px",
//             marginLeft: "4px",
//             fontSize: "0.75rem",
//           },
//           "& .MuiOutlinedInput-root": {
//             borderRadius: 1,
//             backgroundColor: theme.palette.background.paper,

//             "& fieldset": {
//               borderColor: theme.palette.divider,
//             },
//             "&:hover fieldset": {
//               borderColor: theme.palette.text.primary,
//             },
//             "&.Mui-focused fieldset": {
//               borderColor: theme.palette.primary.main,
//             },
//           },
//         }}
//         InputProps={{
//           ...InputProps,
//           style: {
//             color: theme.palette.text.primary,
//             ...(InputProps?.style || {}),
//           },
//         }}
//         placeholder={placeholder}
//         {...props}
//       >
//         {children}
//       </TextField>
//     </Box>
//   );
// };

// export default CustomInput;









import React from "react";
import {
  TextField,
  Box,
  Typography,
  Tooltip,
  MenuItem,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTheme } from "@mui/material/styles";

const CustomInput = ({
  label,
  tooltip,
  type = "text",
  value,
  onChange,
  required = false,
  InputProps = {},
  SelectProps = {},
  placeholder,
  children,
  select = false,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box>
      {label && (
        <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
            }}
          >
            {label}

            {required && (
              <Box
                component="span"
                sx={{
                  color: theme.palette.error.main,
                  ml: 0.25,
                }}
              >
                *
              </Box>
            )}
          </Typography>

          {tooltip && (
            <Tooltip title={tooltip} placement="top">
              <InfoIcon
                sx={{
                  ml: 0.5,
                  fontSize: 16,
                  color: "text.secondary",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          )}
        </Box>
      )}

      <TextField
        select={select}
        required={required}
        type={type}
        value={value}
        onChange={onChange}
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        SelectProps={
          select
            ? {
              displayEmpty: true,
              ...SelectProps,
            }
            : SelectProps
        }
        sx={{
          mb: 1.5,
          position: "relative",

          "& .MuiFormLabel-asterisk": {
            color: theme.palette.error.main,
            fontWeight: 600,
          },

          "& .MuiFormHelperText-root": {
            position: "absolute",
            bottom: "-18px",
            marginLeft: "4px",
            fontSize: "0.75rem",
          },

          "& .MuiOutlinedInput-root": {
            borderRadius: 1,
            backgroundColor: theme.palette.background.paper,

            "& fieldset": {
              borderColor: theme.palette.divider,
            },

            "&:hover fieldset": {
              borderColor: theme.palette.text.primary,
            },

            "&.Mui-focused fieldset": {
              borderColor: theme.palette.primary.main,
            },
          },
        }}
        InputProps={{
          ...InputProps,
          style: {
            color: theme.palette.text.primary,
            ...(InputProps?.style || {}),
          },
        }}
        {...props}
      >
        {select && placeholder && (
          <MenuItem value="" disabled>
            <Typography
              sx={{
                color: theme.palette.text.secondary,
                fontSize: "0.9rem",
              }}
            >
              {placeholder}
            </Typography>
          </MenuItem>
        )}

        {children}
      </TextField>
    </Box>
  );
};

export default CustomInput;